/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function DangerCircleFill({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m.849 8 2.786 2.786a.6.6 0 0 1-.849.849L8 8.849l-2.786 2.786a.6.6 0 0 1-.849-.849L7.151 8 4.365 5.214a.6.6 0 0 1 .849-.849L8 7.151l2.786-2.786a.6.6 0 0 1 .849.849z" clipRule="evenodd" /></svg>;
}
;